import './bootstrap'

import { createApp, h } from 'vue'
import { createInertiaApp, router, usePage } from '@inertiajs/vue3'
import can from '@/Directives/can'
import usePermissions from './Composables/usePermissions'
import { resolvePageComponent } from 'laravel-vite-plugin/inertia-helpers'

const appName = window.document.getElementsByTagName('title')[0]?.innerText || 'ACC'

const permissions = usePermissions()
router.on('navigate', () => {
    let newPermissions = usePage().props.permissions

    if(newPermissions !== null){
        permissions.set(newPermissions ?? [])
    }
})

createInertiaApp({
    title   : (title) => `${title} - ${appName}`,
    resolve : (name) => resolvePageComponent(`./Pages/${name}.vue`, import.meta.glob('./Pages/**/*.vue')),
    setup   : ({ el, App, props, plugin }) => {
        return createApp({ render: () => h(App, props) })
            .use(plugin)
            .mixin({ 
                methods: { 
                    // eslint-disable-next-line no-undef
                    route,
                } 
            })
            .directive('can', can)
            .mount(el)
    },
    progress: {
        color: '#4B5563'
    }
})